/**
 * Compute the page to show after deleting rows from a paginated list.
 * If the current page would be past the last page with data, move to the last valid page.
 */
export function getPageAfterDelete(currentPage, itemsPerPage, totalCount, deletedCount = 1) {
  const remaining = Math.max(0, totalCount - deletedCount);
  if (remaining === 0) return 1;
  const maxPage = Math.ceil(remaining / itemsPerPage) || 1;
  return Math.min(currentPage, maxPage);
}

/**
 * Refresh a paginated list after delete. Call from mutation onSuccess only —
 * do not call fetchData() again from handleConfirmDelete (avoids stale-page race).
 */
export function refreshPaginatedListAfterDelete({
  currentPage,
  setCurrentPage,
  itemsPerPage,
  totalData,
  deletedCount = 1,
  fetchData,
}) {
  const nextPage = getPageAfterDelete(currentPage, itemsPerPage, totalData, deletedCount);
  if (nextPage !== currentPage) {
    setCurrentPage(nextPage);
  } else {
    fetchData();
  }
}
